"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Connected Online heeft mijn e-mailmarketing geoptimaliseerd zodat ik meer tijd kan besteden aan het ontwerpen van mijn kaartjes. Bedankt voor de fijne communicatie",
  author: "Lina",
  role: "Founder bij Novaition",
  rating: 5
}, {
  quote: "De data-gedreven aanpak gecombineerd met een persoonlijke benadering is uniek. Onze social media engagement en conversie zijn nog nooit zo hoog geweest.",
  author: "David de Wit",
  role: "E-commerce Specialist",
  rating: 5
}, {
  quote: "Professioneel, minimalistisch en uiterst effectief. Ze verbinden onze bedrijfsdata aan een strategie die echt resultaat oplevert in meetbare groei en tijdswinst.",
  author: "Elena Rodriguez",
  role: "CEO van Growthly",
  rating: 5
}, {
  quote: "Het automatiseren van onze marketing workflow was de beste beslissing van het jaar. Connected Online maakte de overgang vlekkeloos en menselijk.",
  author: "Julian Bakker",
  role: "Head of Digital Operations",
  rating: 5
}];
export default function KlantenAanHetWoord() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}